import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { TransitionGroup } from 'react-transition-group';

import CssTransition from '../../components/Transition/CssTransition';
import TransitionGroupContainer from '../../components/Transition/TransitionGroupContainer';

import MultiActionsCardDetails from './MultiActionsCardDetails';
import FindLocalRep from '../LocalRep/FindLocalRep';

const MultiActionsCard = () => (
    <Route
        render={({ location }) => (
            <TransitionGroup component={TransitionGroupContainer}>
                <CssTransition key={location.key} timeoutInMs={650}>
                    <Switch location={location}>
                        <Route
                            path="/multiActionsCard"
                            name="MultiActionsCardDetails"
                            exact
                            component={MultiActionsCardDetails}
                        />
                        <Route
                            path="/multiActionsCard/findRep"
                            name="MultiFindRep"
                            exact
                            component={FindLocalRep}
                        />
                    </Switch>
                </CssTransition>
            </TransitionGroup>
        )}
    />
);

export default MultiActionsCard;



// WEBPACK FOOTER //
// ./src/containers/MultiActionsCard/MultiActionsCard.jsx